import conf from "../config";

const constant = {
    CN: 'CN',   //中国 代码
    HK: 'HK',
    TW: 'TW',
    MO: 'MO',
    CN_ITEM: {'CN': "中国"},
    CN_MOBILE: '86',   //手机国家码
    AREA_BEIJING: '010',   //默认地区码 北京
    CN_MOBILE_ITEM: {val: '86', txt: "中国+86"},
    COUNTRY_CN: "中国", //默认国家
    DICT: {
        COUNTRY: "120109",
        COUNTRYCODE_MOBILE: "150136",
        AREACODE_TELPHONE: "150137",
        SPECIALPERSONFLAG: '120200',
        PROVINCE: '190021',
        CAREERTYPE: '150141'
    },
    VAILDDATE_FOREVER: "99991231"
}
export default constant;
